// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c746e0929390f3db814e","655":"308e5d7c60bdb38c0ba4"}[chunkId] + ".js";
};